export enum SurfboardOnboardingStatusEnum {
  APPLICATION_INITIATED = 'APPLICATION_INITIATED',
  APPLICATION_EXPIRED = 'APPLICATION_EXPIRED',
  APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED',
  APPLICATION_PENDING_INFORMATION = 'APPLICATION_PENDING_INFORMATION',
  APPLICATION_SIGNED = 'APPLICATION_SIGNED',
  APPLICATION_COMPLETED = 'APPLICATION_COMPLETED',
  APPLICATION_CREATED = 'APPLICATION_CREATED',
  APPLICATION_REJECTED = 'APPLICATION_REJECTED'
}